module.exports = __webpack_public_path__ + "static/media/TT-Send-for-Approval.26747143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TT-Send-for-Approval.png
// module id = 510
// module chunks = 17